export const hideAuthLoader = () => {
  const loaderElement = document.body.querySelector('#authentication-flow-loader');
  if (loaderElement) {
    loaderElement.parentNode.removeChild(loaderElement);
  }
};
